module.exports = __webpack_public_path__ + "static/talker-0ce505031a9f17180b212168b67d46df.gif";